import { Image, MimeType } from '@udisc/remix-image'

import { Button } from '#app/components/ui/button'
import {
	Sheet,
	SheetClose,
	SheetContent,
	SheetOverlay,
	SheetFooter,
	SheetHeader,
	SheetTitle,
	SheetTrigger,
} from '#app/components/ui/sheet'
import {
	Tooltip,
	TooltipContent,
	TooltipProvider,
	TooltipTrigger,
} from '#app/components/ui/tooltip'
import { cn } from '#app/utils/misc'

export function ImageSheet(data: { data: any }) {
	const imageRows = data.data
	// Tailwind Grid cell classes lookup
	const columnClasses: Record<(typeof imageRows)[number]['column'], string> = {
		1: 'md:col-start-1',
		2: 'md:col-start-2',
		3: 'md:col-start-3',
		4: 'md:col-start-4',
		5: 'md:col-start-5',
		6: 'md:col-start-6',
		7: 'md:col-start-7',
	}
	const rowClasses: Record<(typeof imageRows)[number]['row'], string> = {
		1: 'md:row-start-1',
		2: 'md:row-start-2',
		3: 'md:row-start-3',
		4: 'md:row-start-4',
		5: 'md:row-start-5',
		6: 'md:row-start-6',
		7: 'md:row-start-7',
	}

	//Responsive sizes
	const responsiveSizes = [
		{
			size: {
				width: 150,
				height: 225,
			},
		},
	]
	const loaderURL: string = '/resources/imageserver'

	return (
		<div>
			<ul className="md::mt-0 md::grid md::grid-cols-5 md::grid-rows-6 mt-16 flex max-w-7xl flex-wrap justify-center gap-2 sm:gap-4 md:grid-flow-col">
				<TooltipProvider>
					{imageRows.map(
						(
							row: {
								values: {
									image: { url: string | undefined }
									caption: { valueOf: () => any }
									description: { valueOf: () => any }
								}
								id: any
								name: string | number
							},
							i: number,
						) =>
							//ensure that the image and url are not null, undefined or empty
							row.values.image?.url?.valueOf() && (
								//add a full size image to the responsive sizes
								// responsiveSizes.push({
								// 	size: {
								// 		width: {row.values.image.width?.valueOf(): ?? 800},
								// 		height: { row.values.image.height?.valueOf() ?? '' },
								// 	},
								// }),

								//image and url exist, so render the image

								<li
									// set the key to the id of the row so that react can keep track of the elements
									key={row.id || i}
									// set the class names for the grid cell to position the image in the grid later this can be extended to create groups of images
									className={cn(
										columnClasses[i],
										rowClasses[i],
										'animate-roll-reveal [animation-fill-mode:backwards]',
									)}
									style={{ animationDelay: `${i * 0.02}s` }}
								>
									<Tooltip>
										<TooltipTrigger asChild>
											<div>
												<Sheet>
													<SheetTrigger
														aria-label={`${row.values.image.url?.split('/').pop()?.split('.')[0]}`}
													>
														<div>
															<Image
																width={150}
																height={225}
																src={row.values.image.url}
																alt={row.values.caption?.valueOf() ?? ''}
																loaderUrl={loaderURL}
																responsive={responsiveSizes}
																placeholder="blur"
																loading="eager"
																options={{
																	contentType: MimeType.WEBP,
																}}
															/>
														</div>
													</SheetTrigger>
													<SheetOverlay className="grid place-items-center bg-black/80 px-4 py-16"></SheetOverlay>
													<SheetContent
														side={'bottom'}
														className="max-h-screen overflow-y-auto"
													>
														<SheetHeader>
															<SheetTitle>{row.name?.valueOf()}</SheetTitle>
														</SheetHeader>
														<Image
															width="100%"
															src={row.values.image.url}
															alt={row.values.caption?.valueOf() ?? ''}
															loaderUrl={loaderURL}
															placeholder="blur"
															loading="lazy"
															options={{
																contentType: MimeType.WEBP,
															}}
															//fix the height of the image to 80% of the viewport
														/>
														<div
															dangerouslySetInnerHTML={{
																__html: row.values.description?.valueOf(),
															}}
														/>

														<SheetFooter>
															<SheetClose asChild>
																<Button type="submit">Close</Button>
															</SheetClose>
														</SheetFooter>
													</SheetContent>
												</Sheet>
											</div>
										</TooltipTrigger>
										<TooltipContent>
											{row.values.caption?.valueOf() ?? ''}
										</TooltipContent>
									</Tooltip>
								</li>
							),
					)}
				</TooltipProvider>
			</ul>
		</div>
	)
}
